export function currencyValue(amount: number, currencySymbol = "&pound;") {
	if (typeof amount !== "number") {
		return amount
	}
	return currencySymbol + amount.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
}

export function currencyValueWithoutPence(amount: number, currencySymbol = "&pound;") {
	if (typeof amount !== "number") {
		return amount
	}
	return currencySymbol + amount.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
}

export function intlCurrencyFormat(amount: number) {
	return new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" }).format(amount)
}
